import { IProviderSettings, SETTINGS } from '@spinnaker/core';

export interface IAppengineProviderSettings extends IProviderSettings {
  defaults: {
    account?: string;
    editLoadBalancerStageEnabled?: boolean;
    containerImageUrlDeployments?: boolean;
  };
}

export const AppengineProviderSettings: IAppengineProviderSettings = <IAppengineProviderSettings>SETTINGS.providers.appengine || { defaults: {} };
if (AppengineProviderSettings) {
  AppengineProviderSettings.resetToOriginal = SETTINGS.resetProvider('appengine');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/appengine/appengine.settings.ts